import type { VendingMachineLocation } from '~/contracts/vm';
import { LocationTab } from './LocationInfo.styles';
import LocationTile from './LocationTile';

type OwnProps = {
  vendingMachine: VendingMachineLocation;
};

export default function LocationInfo({ vendingMachine }: OwnProps) {
  const { address, city, state, zip } = vendingMachine;

  return (
    <LocationTab>
      <LocationTile
        title="Address"
        info={`${address} ${city}, ${state} ${zip}`}
        infoLink="Get Directions"
        infoLinkHref={`http://google.com/maps/dir//${address},${city}+${state}+${zip}`.replace(
          ' ',
          '+'
        )}
      />
      <LocationTile
        title="Hours"
        info="9 AM - 7 PM"
        infoLink=""
        infoLinkHref=""
      />
    </LocationTab>
  );
}
